// MainTab wrapper of the slider
// Items data is derived from the MainTabs endpoint

import {
  TEMPLATE_CAROUSEL_TITLE_BELOW,
  TEMPLATE_LIST_LARGE,
  TEMPLATE_LIST_LARGE_NO_TITLE,
  TEMPLATE_LIST_LARGE_OVERLAY,
  TEMPLATE_SLIDER_PORTRAIT,
  TEMPLATE_SLIDER_SQUARE,
} from "@/const.ts";

import { Slider, SliderProps } from "@/components/Content/Slider.tsx";
import { useFullItemsMainTab } from "../hooks/useFullItemsMainTab.tsx";

type MainTabSliderProps = Omit<SliderProps, "fullItems"> & {
  isMixedLayout: boolean;
  templateId: string;
};

const getOrientation = (templateId: string) => {
  switch (templateId) {
    case TEMPLATE_SLIDER_PORTRAIT:
      return "portrait";
    case TEMPLATE_SLIDER_SQUARE:
      return "square";
    default:
      return "landscape";
  }
};

const getSize = (templateId: string) => {
  switch (templateId) {
    case TEMPLATE_LIST_LARGE_OVERLAY:
    case TEMPLATE_LIST_LARGE:
    case TEMPLATE_LIST_LARGE_NO_TITLE:
    case TEMPLATE_CAROUSEL_TITLE_BELOW:
      return "lg";
    default:
      return "sm";
  }
};

export const MainTabSlider = ({
  collection,
  templateId,
  isMixedLayout,
  ...props
}: MainTabSliderProps) => {
  const { fullItems } = useFullItemsMainTab(collection.Items);

  return (
    <Slider
      {...props}
      collection={collection}
      fullItems={fullItems}
      orientation={isMixedLayout ? getOrientation(templateId) : "landscape"}
      size={isMixedLayout ? getSize(templateId) : "sm"}
    />
  );
};
